import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import useModal from '@/common/hooks/useModal';
import FlashIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/flash.svg?react';
import InquiryIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/estealam.svg?react';
import PersonalInquiryForm from '@/modules/adjusterReportModules/IncidentParticipants/components/common/personalInquiry/components/PersonalInquiryForm';
import { useFormContext } from 'react-hook-form';
import { Box } from 'styled-system/jsx';

const PersonalInquiry = ({
  outSideForm,
}: {
  outSideForm: typeof useFormContext;
}) => {
  const { closeModal, open, openModal } = useModal();
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap="16px"
      p="16px"
      borderRadius="8px"
      shadow="cardShadow"
      bg="white"
    >
      <InquiryIcon />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
        gap="6px"
      >
        <Typography textStyle="b1" color="black-1" fontWeight="700">
          استعلام اطلاعات پایه
        </Typography>
        <Typography textStyle="b2" color="black-3">
          استعلام بر اساس کد ملی و تاریخ تولد
        </Typography>
        <Button variant="text" size="small" onClick={openModal}>
          <>
            استعلام
            <FlashIcon />
          </>
        </Button>
        <PersonalInquiryForm
          open={open}
          outSideForm={outSideForm}
          closeModal={closeModal}
        />
      </Box>
    </Box>
  );
};
export default PersonalInquiry;
